const FLAT_ROOF_TYPES = new Set(["platdak", "modern", "basic"]);
const RESTRICTED_ROOF_TYPES = new Set(["basic"]);
const ZERO_OVERHANG_ROOF_TYPES = new Set(["modern"]);

export const isFlatRoofType = (roofType?: string): boolean =>
  Boolean(roofType && FLAT_ROOF_TYPES.has(roofType));

export const isZeroOverhangRoofType = (roofType?: string): boolean =>
  Boolean(roofType && ZERO_OVERHANG_ROOF_TYPES.has(roofType));

export const isRestrictedRoofType = (roofType?: string): boolean =>
  Boolean(roofType && RESTRICTED_ROOF_TYPES.has(roofType));
